import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { proposeDates } from '@api/assetsRent';

import { IProposeDatesForAssetRentItemDTO } from '@interfaces/rent/dto/assetRentDTO';

import { ESnackbarTypes } from '@enums/common';

import { ASSET_RENT_REQUEST_CARD, ASSET_RENT_REQUEST_CARD_ITEMS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateProposeDates = (id: string, onSuccessCallbacks: Array<() => void>) => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutateAsync: proposeDatesForItem,
	} = useMutation<IProposeDatesForAssetRentItemDTO>({
		mutationKey: [ASSET_RENT_REQUEST_CARD, id],
		mutationFn: (params: IProposeDatesForAssetRentItemDTO) => proposeDates(params),
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.assetRentProposedDatesForItemSuccess,
				type: ESnackbarTypes.success,
			}));

			if (onSuccessCallbacks.length) {
				onSuccessCallbacks.forEach((callback) => callback());
			}

			return queryClient.invalidateQueries([ASSET_RENT_REQUEST_CARD_ITEMS]);
		},
		enabled: [id],
	});

	return {
		proposeDatesForItem: proposeDatesForItem,
	};
};
